module.exports = __webpack_public_path__ + "static/media/kick.5ad34163.ogg";